import { createTestIds } from '@duke-hq/lib';

export const testIds = createTestIds('apps-admin-web-Providers-ProviderForm', [
  'form',
  'toggleIsBillable',
  'toggleUseNewReferralProcess',
  'toggleIsExternalIdFieldMandatory',
  'toggleAzureSsoOidc',
  'toggleIncentiveProgramEnabled',
  'downloadSampleCsv',
  'domainList',
  'addDomainInput',
]);
